import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Tooltip,
  Box,
  Chip,
  Fade,
  Badge
} from '@mui/material';
import {
  ReportRounded as ReportRoundedIcon,
  Close as CloseIcon,
  // Warning as WarningIcon,
  // CheckCircle as CheckCircleIcon
} from '@mui/icons-material';

const UnderwritingMessage = ({ underWritingMsg, currentCompany }) => {
  const [openMsg, setOpenMsg] = useState(false);
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Get messages for current company
  const currentCompanyMessages = currentCompany && underWritingMsg && underWritingMsg[currentCompany]
    ? underWritingMsg[currentCompany]
    : [];

//   console.log("underwritingMsg", underWritingMsg);
//   console.log("currentCompany", currentCompany);
//   console.log("currentCompanyMessages", currentCompanyMessages);

  const handleDialogOpen = () => setOpenMsg(true);
  const handleDialogClose = () => setOpenMsg(false);

  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }}>
      {currentCompanyMessages && currentCompanyMessages.length > 0 && (
        <Fade in timeout={800}>
          <Box>
            <Tooltip
              title={
                <Box sx={{ maxWidth: 350 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      mb: 1,
                      color: '#fff',
                      textAlign: 'center'
                    }}
                  >
                    Important Updates - {currentCompany}
                  </Typography>
                  {currentCompanyMessages.slice(0, 2).map((msg, index) => (
                    <Typography
                      key={index}
                      variant="body2"
                      sx={{
                        mb: 0.5,
                        color: '#fff',
                        fontSize: '0.875rem',
                        lineHeight: 1.4
                      }}
                    >
                      • {msg.messageContent.length > 60
                          ? `${msg.messageContent.substring(0, 60)}...`
                          : msg.messageContent}
                    </Typography>
                  ))}
                  {currentCompanyMessages.length > 2 && (
                    <Typography
                      variant="caption"
                      sx={{
                        color: '#ffeb3b',
                        fontStyle: 'italic',
                        display: 'block',
                        textAlign: 'center',
                        mt: 1
                      }}
                    >
                      +{currentCompanyMessages.length - 2} more messages
                    </Typography>
                  )}
                </Box>
              }
              arrow
              placement="top"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: 'rgba(0, 0, 0, 0.9)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: 2,
                    maxWidth: 'none !important'
                  }
                },
                arrow: {
                  sx: {
                    color: 'rgba(0, 0, 0, 0.9)',
                  }
                }
              }}
            >
              <Badge
                badgeContent={currentCompanyMessages.length}
                color="error"
                sx={{
                  '& .MuiBadge-badge': {
                    background: 'linear-gradient(45deg, #ff6b6b, #ee5a24)',
                    color: 'white',
                    fontWeight: 600,
                    fontSize: '0.75rem',
                    animation: 'pulse 2s infinite',
                    '@keyframes pulse': {
                      '0%': { transform: 'scale(1)' },
                      '50%': { transform: 'scale(1.1)' },
                      '100%': { transform: 'scale(1)' }
                    }
                  }
                }}
              >
                <Box
                  onClick={handleDialogOpen}
                  sx={{
                    position: 'relative',
                    cursor: 'pointer',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    borderRadius: '50%',
                    width: 46,
                    height: 46,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 8px 32px rgba(102, 126, 234, 0.4)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                      transform: 'translateY(-4px) scale(1.05)',
                      boxShadow: '0 12px 40px rgba(102, 126, 234, 0.6)',
                      background: 'linear-gradient(135deg, #764ba2 0%, #667eea 100%)',
                    },
                    '&:active': {
                      transform: 'translateY(-2px) scale(1.02)',
                    },
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: -2,
                      left: -2,
                      right: -2,
                      bottom: -2,
                      background: 'linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4)',
                      borderRadius: '50%',
                      opacity: 0,
                      transition: 'opacity 0.3s ease',
                      zIndex: -1,
                    },
                    '&:hover::before': {
                      opacity: 0.3,
                      animation: 'rotate 2s linear infinite',
                      '@keyframes rotate': {
                        '0%': { transform: 'rotate(0deg)' },
                        '100%': { transform: 'rotate(360deg)' }
                      }
                    }
                  }}
                >
                  <ReportRoundedIcon
                    sx={{
                      color: '#fff',
                      fontSize: 20,
                      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))',
                    }}
                  />
                </Box>
              </Badge>
            </Tooltip>
          </Box>
        </Fade>
      )}

      <Dialog
        open={openMsg}
        onClose={handleDialogClose}
        maxWidth="md"
        fullWidth
        disableScrollLock={true}
        keepMounted={false}
        hideBackdrop={false}
        style={{ zIndex: 1300 }}
        PaperProps={{
          sx: {
            borderRadius: 4,
            background: 'linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(255, 251, 235, 0.95))',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 203, 61, 0.3)',
            boxShadow: '0 24px 48px rgba(255, 203, 61, 0.12), 0 0 0 1px rgba(255, 203, 61, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&:before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: 4,
              borderRadius: '16px 16px 0 0',
            }
          }
        }}
        TransitionProps={{
          style: {
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          }
        }}
      >
        <DialogTitle
          sx={{
            background: 'linear-gradient(135deg, rgba(255, 203, 61, 0.08), rgba(255, 215, 0, 0.05))',
            borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
            position: 'relative',
            pt: 3,
            pb: 2.5,
            px: 3,
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            '&:before': {
              content: '""',
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: 4,      
              opacity: 0.8,
            }
          }}
        >
          {/* Icon */}
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              background: 'linear-gradient(45deg, #FFCB3D, #FFD700)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              boxShadow: '0 6px 20px rgba(255, 203, 61, 0.25)',
              mr: 1,
            }}
          >
            <ReportRoundedIcon sx={{ fontSize: 20 }} />
          </Box>

          {/* Title Content */}
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                background: 'linear-gradient(45deg, #FFCB3D, #B8860B)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                color: 'transparent',
                mb: 0.5,
                fontSize: { xs: '1.3rem', sm: '1.5rem' },
              }}
            >
              Underwriting Messages - {currentCompany}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                // color: 'text.secondary',
                 color: 'red',
                fontWeight: 500,
                fontSize: '0.875rem',
              }}
            >
              {currentCompanyMessages?.length || 0} notification{(currentCompanyMessages?.length || 0) !== 1 ? 's' : ''} available
            </Typography>
          </Box>

          {/* Close Button */}
          <IconButton
            onClick={handleDialogClose}
            sx={{
              color: 'text.secondary',
              backgroundColor: 'rgba(0, 0, 0, 0.02)',
              border: '1px solid rgba(0, 0, 0, 0.05)',
              '&:hover': {
                backgroundColor: 'rgba(244, 67, 54, 0.08)',
                color: '#f44336',
                transform: 'rotate(90deg)',
                borderColor: 'rgba(244, 67, 54, 0.2)',
              },
              transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            p: 0,
            background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 251, 235, 0.6) 100%)',
            '&.MuiDialogContent-dividers': {
              borderTop: '1px solid rgba(0, 0, 0, 0.06)',
              borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
            }
          }}
        >
          <Box sx={{ p: 3 }}>
            {currentCompanyMessages?.map((msg, index) => (
              <Box
                key={index}
                sx={{
                  p: 2.5,
                  mb: index < (currentCompanyMessages?.length - 1) ? 2 : 0,
                  borderRadius: 3,
                  background: index % 2 === 0
                    ? 'linear-gradient(135deg, rgba(255, 203, 61, 0.06), rgba(255, 215, 0, 0.04))'
                    : 'linear-gradient(135deg, rgba(255, 165, 0, 0.06), rgba(255, 140, 0, 0.04))',
                  border: '1px solid rgba(0, 0, 0, 0.04)',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  transform: 'translateY(0)',
                  opacity: 1,
                  animation: `slideInUp 0.4s ease-out ${index * 0.1}s both`,
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 25px rgba(255, 203, 61, 0.08)',
                    background: index % 2 === 0
                      ? 'linear-gradient(135deg, rgba(255, 203, 61, 0.1), rgba(255, 215, 0, 0.06))'
                      : 'linear-gradient(135deg, rgba(255, 165, 0, 0.1), rgba(255, 140, 0, 0.06))',
                  },
                  '&:before': {
                    content: '""',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: 4,
                    background: index % 2 === 0
                      ? 'linear-gradient(135deg, #FFCB3D, #FFD700)'
                      : 'linear-gradient(135deg, #FFA500, #FF8C00)',
                    borderRadius: '0 4px 4px 0',
                  },
                  '@keyframes slideInUp': {
                    '0%': {
                      opacity: 0,
                      transform: 'translateY(30px)',
                    },
                    '100%': {
                      opacity: 1,
                      transform: 'translateY(0)',
                    },
                  },
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, pl: 1 }}>
                  {/* Message Icon */}
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      background: index % 2 === 0
                        ? 'linear-gradient(45deg, #FFCB3D, #FFD700)'
                        : 'linear-gradient(45deg, #FFA500, #FF8C00)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      flexShrink: 0,
                      mt: 0.2,
                      boxShadow: '0 2px 8px rgba(255, 203, 61, 0.15)',
                    }}
                  >
                    {index + 1}
                  </Box>

                  {/* Message Content */}
                  <Typography
                    gutterBottom={false}
                    sx={{
                      color: 'text.primary',
                      fontWeight: 500,
                      lineHeight: 1.6,
                      flex: 1,
                      fontSize: { xs: '0.9rem', sm: '1rem' },
                      '&:before': {
                        content: '"•"',
                        color: index % 2 === 0 ? '#FFCB3D' : '#FFA500',
                        fontWeight: 'bold',
                        marginRight: 1,
                        fontSize: '1.2em',
                      },
                    }}
                  >
                    {msg.messageContent}
                  </Typography>
                </Box>
              </Box>
            ))}

            {/* Empty State */}
            {(!currentCompanyMessages || currentCompanyMessages.length === 0) && (
              <Box
                sx={{
                  textAlign: 'center',
                  py: 6,
                  color: 'text.secondary',
                }}
              >
                <Typography variant="h6" gutterBottom>
                  No messages available
                </Typography>
                <Typography variant="body2">
                  All underwriting updates for {currentCompany} will appear here
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            p: 3,
            background: 'linear-gradient(135deg, rgba(255, 203, 61, 0.02), rgba(255, 215, 0, 0.02))',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          {/* Info Badge */}
          <Chip
            label={`${currentCompanyMessages?.length || 0} messages`}
            size="small"
            sx={{
            //   background: 'linear-gradient(45deg, #FFF8E1, #FFFBF0)',
            background: 'linear-gradient(45deg,rgb(252, 10, 10),rgb(252, 10, 10))',
              color: '#FFCB3D',
              border: '1px solid rgba(255, 203, 61, 0.2)',
              fontWeight: 500,
              '& .MuiChip-icon': {
                color: '#FFCB3D',
              },
            }}
          />

          {/* Action Buttons */}
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              onClick={handleDialogClose}
              variant="contained"
              sx={{
                background: 'linear-gradient(45deg, #FFCB3D, #FFD700)',
                color: 'white',
                fontWeight: 600,
                px: 4,
                py: 1.2,
                borderRadius: 2.5,
                textTransform: 'none',
                fontSize: '1rem',
                boxShadow: '0 6px 20px rgba(255, 203, 61, 0.25)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                position: 'relative',
                overflow: 'hidden',
                minWidth: 120,
                '&:hover': {
                  background: 'linear-gradient(45deg, #E6B800, #DAA520)',
                  boxShadow: '0 8px 28px rgba(255, 203, 61, 0.35)',
                  transform: 'translateY(-1px)',
                },
                '&:before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent)',
                  transform: 'translateX(-100%)',
                  transition: 'transform 0.6s',
                },
                '&:hover:before': {
                  transform: 'translateX(100%)',
                },
                transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            >
              ✓ Got it!
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default UnderwritingMessage;